<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden"></div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <div class="Polaris-Grid">
                  <div
                    class="Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                  >
                    <div class="Polaris-LegacyCard">
                      <div class="Polaris-CalloutCard__Container">
                        <div
                          class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                        >
                          <div class="Polaris-CalloutCard">
                            <div class="Polaris-CalloutCard__Content">
                              <div class="Polaris-CalloutCard__Title">
                                <h2
                                  class="Polaris-Text--root Polaris-Text--headingMd"
                                >
                                  Welcome Notification
                                  <Badge
                                    :title="
                                      getBadgeTitle('welcomeNotification')
                                    "
                                    :type="getBadgeType('welcomeNotification')"
                                  />
                                </h2>
                              </div>
                              <div class="Polaris-TextContainer">
                                <p>
                                  A sequence of notifications sent to the
                                  subscriber once they subscribe to your store
                                  notifications
                                </p>
                              </div>
                              <div class="Polaris-CalloutCard__Buttons">
                                <router-link
                                  class="Polaris-Button"
                                  to="/welcomenotifications"
                                  data-polaris-unstyled="true"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Customize</span
                                    >
                                  </span>
                                </router-link>
                              </div>
                            </div>
                            <img
                              alt=""
                              src="https://instaimages.carthike.com/pushhike/welcome_notification.svg"
                              class="Polaris-CalloutCard__Image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                  >
                    <div class="Polaris-LegacyCard">
                      <div class="Polaris-CalloutCard__Container">
                        <div
                          class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                        >
                          <div class="Polaris-CalloutCard">
                            <div class="Polaris-CalloutCard__Content">
                              <div class="Polaris-CalloutCard__Title">
                                <h2
                                  class="Polaris-Text--root Polaris-Text--headingMd"
                                >
                                  Abandoned Cart
                                  <Badge
                                    :title="
                                      getBadgeTitle('abandonedCartNotification')
                                    "
                                    :type="
                                      getBadgeType('abandonedCartNotification')
                                    "
                                  />
                                </h2>
                              </div>
                              <div class="Polaris-TextContainer">
                                <p>
                                  A sequence of notifications to remind the
                                  subscriber about the items they forgot in
                                  their cart
                                </p>
                              </div>
                              <div class="Polaris-CalloutCard__Buttons">
                                <router-link
                                  class="Polaris-Button"
                                  to="/abandonedcart"
                                  data-polaris-unstyled="true"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Customize</span
                                    >
                                  </span>
                                </router-link>
                              </div>
                            </div>
                            <img
                              alt=""
                              src="https://instaimages.carthike.com/pushhike/abandoned_cart.svg"
                              class="Polaris-CalloutCard__Image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                  >
                    <div class="Polaris-LegacyCard">
                      <div class="Polaris-CalloutCard__Container">
                        <div
                          class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                        >
                          <div class="Polaris-CalloutCard">
                            <div class="Polaris-CalloutCard__Content">
                              <div class="Polaris-CalloutCard__Title">
                                <h2
                                  class="Polaris-Text--root Polaris-Text--headingMd"
                                >
                                  Order Shipping Update
                                  <Badge title="Early Access" type="info" />
                                </h2>
                              </div>
                              <div class="Polaris-TextContainer">
                                <p>
                                  Notification will be sent once the order is
                                  fulfilled along with the tracking URL
                                </p>
                              </div>
                              <div class="Polaris-CalloutCard__Buttons">
                                <button
                                  v-if="!store.hasAccessForOrderNotification"
                                  class="Polaris-Button"
                                  to="/ordershipping"
                                  data-polaris-unstyled="true"
                                  @click="earlyAccessInterest"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Get Early Access</span
                                    >
                                  </span>
                                </button>
                                <router-link
                                  v-if="store.hasAccessForOrderNotification"
                                  class="Polaris-Button"
                                  to="/ordershipping"
                                  data-polaris-unstyled="true"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Customize</span
                                    >
                                  </span>
                                </router-link>
                              </div>
                            </div>
                            <img
                              alt=""
                              src="https://instaimages.carthike.com/pushhike/shipping_update.svg"
                              class="Polaris-CalloutCard__Image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="Polaris-Grid-Cell Polaris-Grid-Cell--cell_6ColumnXs Polaris-Grid-Cell--cell_3ColumnSm Polaris-Grid-Cell--cell_3ColumnMd Polaris-Grid-Cell--cell_6ColumnLg Polaris-Grid-Cell--cell_6ColumnXl"
                  >
                    <div class="Polaris-LegacyCard">
                      <div class="Polaris-CalloutCard__Container">
                        <div
                          class="Polaris-LegacyCard__Section Polaris-LegacyCard__FirstSectionPadding Polaris-LegacyCard__LastSectionPadding"
                        >
                          <div class="Polaris-CalloutCard">
                            <div class="Polaris-CalloutCard__Content">
                              <div class="Polaris-CalloutCard__Title">
                                <h2
                                  class="Polaris-Text--root Polaris-Text--headingMd"
                                >
                                  Campaigns
                                  <Badge title="Coming Soon" type="info" />
                                </h2>
                              </div>
                              <div class="Polaris-TextContainer">
                                <p>
                                  Send a personalized push notifications to your
                                  customer list.
                                </p>
                              </div>
                              <div class="Polaris-CalloutCard__Buttons">
                                <!-- <button
                                  class="Polaris-Button"
                                  to="/ordershipping"
                                  data-polaris-unstyled="true"
                                  @click="earlyAccessInterestCampaigns"
                                >
                                  <span class="Polaris-Button__Content">
                                    <span class="Polaris-Button__Text"
                                      >Get Early Access</span
                                    >
                                  </span>
                                </button> -->
                              </div>
                            </div>
                            <img
                              alt=""
                              src="https://instaimages.carthike.com/pushhike/shipping_update.svg"
                              class="Polaris-CalloutCard__Image"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";

import Page from "./Page";
import Badge from "./Badge.vue";

export default {
  name: "AutomationList",

  data() {
    return {
      pageTitle: "Automations",
      isLoading: false,
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false,
      products: {},
      notificationConfig: {}
    };
  },
  components: {
    Page,
    Badge
    // Spinner
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    },
    store() {
      return this.$store.getters.getStore;
    }
  },
  created() {
    this.$store.dispatch("getConfig");

    this.getAutomationConfig();
  },
  mounted() {
    // eslint-disable-next-line
    // googleTranslateElementInit();
  },
  methods: {
    async getAutomationConfig() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.notificationConfig = response.config;
        this.isLoading = false;
      });
    },
    getBadgeTitle(key) {
      if (this.notificationConfig && this.notificationConfig[key]) {
        return this.notificationConfig[key].isEnabled ? "Active" : "Inactive";
      }
      return "Inactive";
    },
    getBadgeType(key) {
      if (this.notificationConfig && this.notificationConfig[key]) {
        return this.notificationConfig[key].isEnabled ? "success" : "attention";
      }
      return "info";
    },
    earlyAccessInterest() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          "Hi I am interested in Order Notifications, Can I get an early access?"
        ]
      ]);
    },
    earlyAccessInterestCampaigns() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        ["text", "Hi I am interested in Campaigns, Can I get an early access?"]
      ]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
